import React from "react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { Link } from "react-router-dom";

const tocItems = [
  { id: "coverage", label: "1. Delivery Coverage" },
  { id: "processing", label: "2. Order Preparation Time" },
  { id: "methods", label: "3. Delivery Method" },
  { id: "delivery", label: "4. Delivery Timelines" },
  { id: "tracking", label: "5. Order Updates" },
  { id: "packaging", label: "6. Packaging Standards" },
  { id: "delays", label: "7. Delivery Limitations" },
  { id: "contact", label: "8. Contact & Support" },
];

export default function ShippingPolicyPage() {
  return (
    <>
      <Navbar />
      <div className="policy-page">
        <div className="policy-container">
          <div className="breadcrumb__list mb-30">
            <span>
              <Link to="/">Home</Link>
            </span>
            <span className="dvdr">
              <i className="fa-regular fa-angle-right"></i>
            </span>
            <span>Shipping Policy</span>
          </div>
          <header className="policy-header">
            <h1>Shipping & Delivery Policy</h1>
            <p className="policy-updated">
              <strong>Last updated:</strong> January 01, 2026
            </p>

            <p>
              At <strong>A1 Sweets & Bakery</strong>, we focus on delivering
              freshly prepared sweets and bakery items within our local service
              areas with care and reliability.
            </p>

            <p>
              This policy explains how we handle order preparation, dispatch,
              and delivery for all purchases made with us.
            </p>
          </header>

          {/* TOC */}
          <section className="policy-toc">
            <h2>Quick Navigation</h2>
            <ul>
              {tocItems.map((item) => (
                <li key={item.id}>
                  <a href={`#${item.id}`}>{item.label}</a>
                </li>
              ))}
            </ul>
          </section>

          {/* 1. Coverage */}
          <section id="coverage" className="policy-section">
            <h2>1. Delivery Coverage</h2>

            <p>We currently offer delivery only within the following areas:</p>

            <ul>
              <li>
                <strong>Madurai</strong>
              </li>
              <li>
                <strong>Peraiyur</strong>
              </li>
            </ul>

            <p>
              Orders placed from outside these locations cannot be fulfilled at
              this time. We may expand our delivery coverage in the future.
            </p>
          </section>

          {/* 2. Processing */}
          <section id="processing" className="policy-section">
            <h2>2. Order Preparation Time</h2>

            <ul>
              <li>Orders are prepared only after payment confirmation</li>
              <li>
                Preparation time is typically{" "}
                <strong>within 1–2 working days</strong>
              </li>
              <li>
                Orders placed on weekends will be handled on the next working
                day
              </li>
            </ul>

            <p>
              Since our products are freshly made, slight delays may occur
              during peak demand or festive periods.
            </p>
          </section>

          {/* 3. Methods */}
          <section id="methods" className="policy-section">
            <h2>3. Delivery Method</h2>

            <p>
              We use trusted local delivery partners and in-house delivery
              services to ensure safe handling of food items.
            </p>

            <ul>
              <li>Delivery method depends on order size and location</li>
              <li>
                All deliveries are handled with care to maintain freshness
              </li>
              <li>No third-party long-distance courier shipping is used</li>
            </ul>
          </section>

          {/* 4. Delivery */}
          <section id="delivery" className="policy-section">
            <h2>4. Delivery Timelines</h2>

            <ul>
              <li>
                Orders are typically delivered within{" "}
                <strong>1–3 working days</strong> after preparation
              </li>
            </ul>

            <p>Delivery time may vary depending on:</p>

            <ul>
              <li>Exact delivery location</li>
              <li>Order volume</li>
              <li>Weather or traffic conditions</li>
            </ul>
          </section>

          {/* 5. Tracking */}
          <section id="tracking" className="policy-section">
            <h2>5. Order Updates</h2>

            <ul>
              <li>You will receive confirmation once your order is accepted</li>
              <li>Delivery updates will be shared via phone or WhatsApp</li>
              <li>
                Direct tracking links may not be available for local deliveries
              </li>
            </ul>

            <p>
              For real-time updates, you can contact our support team anytime.
            </p>
          </section>

          {/* 6. Packaging */}
          <section id="packaging" className="policy-section">
            <h2>6. Packaging Standards</h2>

            <p>
              We ensure all products are packed with care to maintain hygiene
              and freshness.
            </p>

            <ul>
              <li>Clean and food-safe packaging materials</li>
              <li>Secure packing to avoid spills or damage</li>
              <li>Handled carefully during transport</li>
            </ul>
          </section>

          {/* 7. Delays */}
          <section id="delays" className="policy-section">
            <h2>7. Delivery Limitations</h2>

            <p>Delivery may be affected or delayed due to the following:</p>

            <ul>
              <li>Incorrect delivery details provided</li>
              <li>Customer unavailable at delivery location</li>
              <li>Unexpected local conditions (rain, traffic, etc.)</li>
            </ul>

            <p>
              While we try our best to deliver on time, slight delays may occur
              in such situations.
            </p>
          </section>

          {/* 8. Contact */}
          <section id="contact" className="policy-section">
            <h2>8. Contact & Support</h2>

            <div className="contact-grid">
              <div className="contact-card">
                <h3>Phone</h3>
                <p>
                  <strong>Mobile:</strong> +91 9751336638
                </p>
              </div>

              <div className="contact-card">
                <h3>Email</h3>
                <p>
                  <a href="mailto:a1foodfactory2008@gmail.com">
                    a1foodfactory2008@gmail.com
                  </a>
                </p>
              </div>

              <div className="contact-card full-width">
                <h3>Location</h3>
                <p>
                  <strong>A1 Sweets & Bakery</strong>
                  <br />
                  Peraiyur, Tamil Nadu
                </p>
              </div>
            </div>

            <p style={{ marginTop: "20px" }}>
              For any delivery-related questions, feel free to contact us. We’re
              always happy to assist you.
            </p>
          </section>
        </div>
      </div>
      <Footer />
    </>
  );
}
